module.exports = __webpack_public_path__ + "img/bottom.95fd4798.png";